import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpServiceProvider {

  URL_API = 'atecgestao.masterdaweb.net'
  constructor(public http: HttpClient) { }

  get(endpoint, params = '') {
    let url = 'http://' + this.URL_API + '/pedidoonline/response/' + endpoint + '.php?bd=' + localStorage.getItem("database") + '&numFilial=' + localStorage.getItem("filial");
    if (params != '') {
      url = url + params;
    }

    return this.http.get(url);
  }

  getCep(cep) {
    return this.http.get("https://viacep.com.br/ws/" + cep + "/json/")
  }
}



// WEBPACK FOOTER //
// ./src/providers/http-service/http-service.ts